export default __webpack_public_path__ + "static/media/baseline-close-black-24px.be61acde.svg";